export const classSyllabus = [
	{
		id: "1",
		class: "Year 1",
		section: "Jupiter",
		subjectGroup: "Year 1, Saturn  English",
		createdDate: "10 May 2024",
		status: "Active",
		key:1,
	},
	{
		id: "2",
		class: "Year 1",
		section: "Mars",
		subjectGroup: "Year 3, Jupiter  Maths",
		createdDate: "11 May 2024",
		status: "Active",
		key:2,
	},
	{
		id: "3",
		class: "Year 2",
		section: "Jupiter",
		subjectGroup: "Year 2, Jupiter  English",
		createdDate: "12 May 2024",
		status: "Active",
		key:3,
	},
	{
		id: "4",
		class: "Year 2",
		section: "Mars",
		subjectGroup: "Year 4, Jupiter  Physics",
		createdDate: "13 May 2024",
		status: "Active",
		key:4,
	},
	{
		id: "5",
		class: "Year 2",
		section: "Saturn",
		subjectGroup: "Year 5, Jupiter  Chemistry",
		createdDate: "14 May 2024",
		status: "Active",
		key:5,
	},
	{
		id: "6",
		class: "Year 3",
		section: "Jupiter",
		subjectGroup: "Year 3, Mars  Maths",
		createdDate: "15 May 2024",
		status: "Active",
		key:6,
	},
	{
		id: "7",
		class: "Year 3",
		section: "Mars",
		subjectGroup: "Year 4, Mars  Chemistry",
		createdDate: "16 May 2024",
		status: "Active",
		key:7,
	},
	{
		id: "8",
		class: "Year 4",
		section: "Jupiter",
		subjectGroup: "Year 1, Mars  Maths",
		createdDate: "17 May 2024",
		status: "Active",
		key:11,
	},
	{
		id: "9",
		class: "Year 4",
		section: "Mars",
		subjectGroup: "Year 6, Mars  Chemistry",
		createdDate: "18 May 2024",
		status: "Active",
		key:8,
	},
	{
		id: "10",
		class: "V",
		section: "Jupiter",
		subjectGroup: "Year 4, Jupiter Maths",
		createdDate: "19 May 2024",
		status: "Active",
		key:9,
	}
];
